export class IntegrateAdapter {
  static toOutputDTO(res: any): boolean {
    return res.linked;
  }
}
